module.exports = __webpack_public_path__ + "static/media/amani.62a70ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/equipe/amani.png
// module id = 2265
// module chunks = 0